module.exports = __webpack_public_path__ + "img/denmark-infectious-diseases-male.adc85b75.png";